import HttpClient from '../../../__core/Providers/HttpClient/HttpClientInstance';
import { ReduxAction, ReduxDispatch } from '../../../Configs/Redux/Types';
import { get } from 'lodash';
import { getUserSuccess } from './ActionCreators';

export function fetchUser(): ReduxAction<Promise<unknown>> {
  const url = 'users/me';

  return (dispatch: ReduxDispatch): Promise<unknown> => {
    return new Promise<unknown>((resolve, reject) => {
      HttpClient.get(url)
        .then((response) => {
          dispatch(getUserSuccess(get(response, 'data')));
          resolve(response);
        })
        .catch(reject);
    });
  };
}

export function fetchLang(): Promise<string> {
  const url = 'language';

  return new Promise<string>((resolve, reject) => {
    HttpClient.get(url)
      .then((response) => resolve(get(response, 'data.lang')))
      .catch(reject);
  });
}

export function setAppLang(lang: string): Promise<unknown> {
  const url = `language/${lang}`;

  return new Promise<unknown>((resolve, reject) => {
    HttpClient.put(url).then(resolve).catch(reject);
  });
}

export function changePassword(
  userId: number,
  oldPassword: string,
  newPassword: string
): Promise<unknown> {
  const url = `user/${userId}/change-password`;

  const data = new URLSearchParams();
  data.append('oldPassword', oldPassword);
  data.append('newPassword', newPassword);

  return new Promise<unknown>((resolve, reject) => {
    HttpClient.put(url, data).then(resolve).catch(reject);
  });
}

export function changeUsername(
  userId: number,
  name: string,
  surname: string,
  password: string
): Promise<unknown> {
  const url = `user/${userId}/profile`;

  const data = new URLSearchParams();
  data.append('name', name);
  data.append('surname', surname);
  data.append('password', password);

  return new Promise<unknown>((resolve, reject) => {
    HttpClient.put(url, data).then(resolve).catch(reject);
  });
}
